import React from 'react'
import '../App.css'

function Phase() {
  return (
    <div className='phase-container'>
        <div>
            <h1>Phase 1</h1>
            <ul>
                <li>Launch</li>
                <li>Dexscreener/ Dextools Update</li>
                <li>CoinGecko/Coinmarketcap Listings</li>
                <li>690+ Holders</li>
                <li>Cultivate the Bitcoin Army</li>
            </ul>
        </div>

        <div>
            <h1>Phase 2</h1>
            <ul>
                <li>Partnerships</li>
                <li>Guerilla Marketing (we’ll be everywhere)</li>
                <li>Exclusive holder content/community hang outs</li>
                <li>2500+ holders</li>
                <li>CEX Listings</li>
            </ul>
        </div>


        <div>
            <h1>Phase 3</h1>
            <ul>
                <li>Website rebuilt</li>
                <li>Utility partnerships</li>
                <li>Multichain bridging</li>
                <li>T1 Exchange Listings</li>
                <li>10,000+ holders Flip Bitcoin</li>
            </ul>
        </div>
    </div>
  )
}

export default Phase